import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import InputSelect from '../../../common/components/form-elements/InputSelect';
import cssCheckbox from '../../assets/scss/Checkbox.scss';
import cssForms from '../../assets/scss/Forms.scss';
import { config } from '../../common';
import { useRouter } from '../../common/RouterHooks';
import DeleteCardContainer, { DeleteCardProps } from './containers/DeleteCardContainer';

interface DeleteCardEvents {
    onCancel: () => void;
    onSubmit: () => void;
}

const DeleteCard: React.FC<DeleteCardEvents> = (containerProps) => {
    const { t } = useTranslation();
    const routeProps = useRouter();
    return (
        <DeleteCardContainer {...containerProps} t={t} routeProps={routeProps} >
            {(props: DeleteCardProps) => {
                return (
                    <React.Fragment>
                        <h4>{t('cards:deleteCard.header')}</h4>
                        <form className={cssForms.form}>
                            <ul className={classNames(['no-bullet', 'dados-viatura'])}>
                                <li>
                                    <span className={'valor'}>{t(`cards:deleteCard.description`)}</span>
                                </li>
                                <li>
                                    <InputSelect {...props.licensePlateSelect} />
                                    <div className="error-message">{props.licensePlateSelect.errorText}</div>
                                </li>
                                <li className={classNames([(config.BrandEnv === 'BMW' ? cssCheckbox.bmw : cssCheckbox.mini)])} style={{ padding: '10px 0px' }}>
                                    <div className={cssCheckbox.inputCheckboxSmall}>
                                        <label className={cssCheckbox.center}>
                                            <input type="checkbox" checked={props.confirmation} onChange={props.onConfirmChange} />
                                            <i />
                                            <span>{t('cards:deleteCard.checkboxText')}</span>
                                        </label>
                                    </div>
                                </li>
                                <li>
                                    <div className="error-message">{props.submitErrorText}</div>
                                    <div className={'button-group'}>
                                        <button type="button" className={classNames(['button', 'bttSubscrever'])} {...props.btnSubmit} onClick={(e) => { props.btnSubmit.onClick(e, containerProps.onSubmit); }}>{props.btnSubmit.disabled ? t('loadingText') : t('cards:deleteCard.submit')}</button>
                                        <button type="button" className={classNames(['button', 'bttCancelar'])} onClick={() => { containerProps.onCancel(); }}>{t('cancel')}</button>
                                    </div>
                                </li>
                            </ul>
                        </form>
                    </React.Fragment>
                );
            }}
        </DeleteCardContainer>
    );
};

export default DeleteCard;
